import { useEffect, useState } from "react";
import Nav from "./components/Nav";
import useMediaQuery from './hooks/useMediaQuery';

import Hero from './components/Hero';
import About from './components/About';
import Menu from './components/Menu';
import Team from './components/Team';
import Testimonial from './components/Testimonial';
import WriteUs from './components/WriteUs';
import Footer from './components/Footer';

import PhotoBook from "./components/PhotoBook";

function App () {
  const [selectedPage, setSelectedPage] = useState('home');
  const [isTopOfPage, setIsTopOfPage] = useState(true);
  const isAboveMediumScreens = useMediaQuery('(min-width: 1060px)');

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setIsTopOfPage(true);
        setSelectedPage("home");
      }
      if (window.scrollY !== 0) setIsTopOfPage(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return ( 
  <div className="app">
    <Nav 
    isTopOfPage = {isTopOfPage}
    selectedPage = {selectedPage} 
    setSelectedPage = {setSelectedPage}
    />
    
    <Hero setSelectedPage={setSelectedPage} />
    <About setSelectedPage={setSelectedPage} />
    <Team setSelectedPage={setSelectedPage} />
    <Menu setSelectedPage={setSelectedPage} />
    <WriteUs setSelectedPage={setSelectedPage} />
    <Testimonial setSelectedPage={setSelectedPage}/>
    <Footer setSelectedPage={setSelectedPage}/>
  </div>
  );
};

export default App;